import { map } from "rxjs";
import { StripeCoupon } from "../../../model";
import { apiService } from "../../ApiService";

export const getStripeCoupon = (coupon: string, plan: string) =>
  apiService
    .get<{ coupon: StripeCoupon }>({
      path: `v1/store/stripe/coupon?label=${coupon}&plan=${plan}`,
    })
    .pipe(map((e) => e.coupon));
